import { useTranslation } from 'react-i18next';

import { toast } from '@feathr/components';

import type { IDonationCreatedEvent } from './fundraisingEvents.types';
import useFundraisingEvents from './useFundraisingEvents';

/**
 * Shows toast notifications when new donations are received via realtime events.
 */
function useDonationToasts(): void {
  const { t } = useTranslation();

  useFundraisingEvents({
    onDonationCreated: (donation: IDonationCreatedEvent) => {
      const donorName = `${donation.donor_first_name} ${donation.donor_last_name}`.trim();
      const amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(donation.amount);

      toast(t('New donation received!'), {
        type: 'success',
        description: t('{{donor}} donated {{amount}}', {
          donor: donorName || t('Anonymous'),
          amount,
        }),
      });
    },
  });
}

export { useDonationToasts };
